import "./JobCardComponent.scss";
import { Tag, Tooltip } from "antd";
import { useCallback } from "react";
import { ImageConfig } from "../../../constants";
import { CommonService } from "../../../helpers";

interface JobCardComponentProps {
    job_details: any;
    handleCardClick?: (id: any) => void;
    selectedJobId?: any;
}

const JOB_TYPE_TAG: Record<string, { label: string; color: string }> = {
    contract: { label: 'Contract', color: 'green' },
    permanent: { label: 'Permanent', color: 'purple' },
    per_diem: { label: 'Per Diem', color: 'orange' },
    locum: { label: 'Locum', color: 'cyan' },
};

const JobCardComponent = (props: JobCardComponentProps) => {
    const { job_details, handleCardClick, selectedJobId } = props;

    const remoteJob = useCallback((value: string) => {
        const mapping: Record<string, string> = {
            Yes: "Remote",
            No: "On-Site",
            Hybrid: "Hybrid"
        };
        return mapping[value] || "On-Site";
    }, []);

    const handleClick = useCallback((id) => {
        handleCardClick?.(id)
    }, [handleCardClick])

    return (
        <div
            className={`job-card-component ${selectedJobId === job_details?._id ? 'active-card' : ''} ${job_details?.is_hot_job ? 'hot-job-card' : ''}`}
            onClick={() => handleClick(job_details?._id)}
            data-job-id={job_details?._id}
        >
            <div className={'job-card-title-wrapper'}>
                <div className={'job-card-title'}>
                    {job_details?.job_title}
                    {job_details?._id && (
                        <div className={'job-card-job-id'}>
                            Job ID: {job_details._id.slice(-7)}
                        </div>
                    )}
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
                    {job_details?.is_hot_job && (
                        <Tag color={'red'} style={{
                            fontWeight: 600,
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                            🔥 Hot Job
                        </Tag>
                    )}
                    {job_details?.job_type && (
                        <Tag color={JOB_TYPE_TAG[job_details.job_type]?.color ?? 'default'}>
                            {JOB_TYPE_TAG[job_details.job_type]?.label ?? job_details.job_type}
                        </Tag>
                    )}
                    <Tag color={'blue'}>{remoteJob(job_details?.remote_job)}</Tag>
                </div>
            </div>
            <div className={'job-card-address'}>
                {[
                    job_details?.address?.city,
                    job_details?.address?.state
                ].filter(Boolean).join(", ")}
            </div>
            {
                job_details?.customer_name?.trim() && (
            
            <Tooltip title="Company">
                <div className={'job-card-icon-wrapper'}>
                    <div className={'display-center'}>
                        <img
                            src={ImageConfig.CompanyIcon}
                            alt=""
                            width={20}
                            height={20}
                            className="job-card-company-icon"
                        />
                    </div>
                    <div className={'job-card-address'}>
                        {job_details?.customer_name?.trim() || 'N/A'}
                    </div>
                </div>
            </Tooltip>
            )}
            <div>
                {job_details?.job_type === 'permanent' &&
                    <div className={'job-salary-range'}>
                        {/** job_details?.pay_rate && Number(job_details?.pay_rate) !== 0 ?
                            <>
                                ${Number(job_details.pay_rate)?.toFixed(2)}/Year
                            </> :
                            <div className={'job-salary-range-title'}>
                                Salary will vary based on experience.
                            </div>
                        **/}
                        <div className={'job-salary-range-title'}>
                            Salary will vary based on experience.
                        </div>
                    </div>
                }
                {job_details?.job_type === 'per_diem' &&
                    <div className={'job-salary-range'}>
                        {job_details?.pay_rate && Number(job_details?.pay_rate) !== 0 ?
                            <>
                                ${Number(job_details?.pay_rate)?.toFixed(2)}/Hr
                            </> :
                            <div className={'job-salary-range-title'}>
                                Salary Not Disclosed
                            </div>
                        }
                    </div>
                }
                {(job_details?.job_type === 'contract' || job_details?.job_type === 'locum') &&
                    <div className={'job-salary-range'}>
                        {job_details?.pay_rate && Number(job_details?.pay_rate) !== 0 ?
                            <>
                                ${Number(job_details?.pay_rate)?.toFixed(2)}/Week
                            </> :
                            <div className={'job-salary-range-title'}>
                                Salary Not Disclosed
                            </div>
                        }
                    </div>
                }
            </div>
            <Tooltip title="Profession">
                <div className={'job-card-icon-wrapper'}>
                    <div className={'display-center'}>
                        <ImageConfig.ProfessionIcon />
                    </div>
                    <div className={'job-card-address'}>{job_details?.staff_type || 'N/A'}</div>
                </div>
            </Tooltip>

            {job_details?.job_type === 'per_diem' && typeof (job_details?.per_diem_details?.start_time) === "number" && typeof (job_details?.per_diem_details?.end_time) === "number" && (
                <Tooltip title="Shift timing">
                    <div className={'job-card-icon-wrapper'}>
                        <div className={'display-center'}>
                            <ImageConfig.TimeIcon />
                        </div>
                        <div className={'job-card-address'}>
                            <div className={'job-card-per-diem-timings'}>
                                {CommonService?.convertMinsToHrsMins(job_details?.per_diem_details?.start_time)}
                                {" - "}
                                {CommonService?.convertMinsToHrsMins(job_details?.per_diem_details?.end_time)}
                            </div>
                        </div>
                    </div>
                </Tooltip>
            )}
            {(job_details?.job_type === 'contract' || job_details?.job_type === 'locum') && job_details?.contract_details?.days_per_week && job_details?.contract_details?.shift_duration &&  (
                <Tooltip title="Shift timing">
                    <div className={'job-card-icon-wrapper'}>
                        <div className={'display-center'}>
                            <ImageConfig.TimeIcon />
                        </div>
                        <div className={'job-card-address'}>
                            <div className={'job-card-timings-wrapper'}>
                                {job_details?.contract_details.days_per_week} x{' '}
                                {job_details?.contract_details.shift_duration} hrs
                            </div>
                        </div>
                    </div>
                </Tooltip>
            )}


            <Tooltip title={"Start Date"}>
                <div className={'job-card-icon-wrapper'}>
                    <div>
                        <ImageConfig.DateIcon />
                    </div>
                    <div className={'job-card-address'}>
                        {job_details?.job_type === 'per_diem' &&
                            <div className={'job-card-per-diem-timings'}>
                                {job_details?.per_diem_details?.start_date ? CommonService.formattedDate(job_details?.per_diem_details?.start_date) : 'ASAP'}
                            </div>
                        }
                        {job_details?.job_type === 'permanent' &&
                            <div className={'job-card-per-diem-timings'}>
                                <div className={'job-card-timings-wrapper'}>
                                    {job_details?.job_start_date ? CommonService.formattedDate(job_details?.job_start_date) : 'ASAP'}{" "}
                                </div>
                            </div>
                        }
                        {(job_details?.job_type === 'contract' || job_details?.job_type === 'locum') &&
                            <div className={'job-card-timings-wrapper'}>
                                {job_details?.contract_details?.start_date ? CommonService.formattedDate(job_details?.contract_details?.start_date) : 'ASAP'}
                            </div>
                    }
                    </div>
                </div>
            </Tooltip>
            <div className={'job-card-icon-wrapper'}>
                <div className={'display-center'}>
                    <ImageConfig.RelativeTimeIcon />
                </div>
                <div className={'job-card-address'}>
                    {CommonService.getRelativeDate(job_details?.created_at)}
                </div>
            </div>
        </div>
    )
}

export default JobCardComponent
